import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { lastValueFrom, map } from 'rxjs';
import { FinancialAdminControllerService } from 'src/app/admin-api';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-webhooks',
  templateUrl: './webhooks.component.html',
  styleUrl: './webhooks.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class WebhooksComponent implements OnInit {
  financialAdminService = inject(FinancialAdminControllerService);
  private messageService = inject(MessageService);

  webhookrec = new FormControl<string>(null, Validators.required);
  webhook = new FormControl<string>(null, Validators.required);
  webhookcobr = new FormControl<string>(null, Validators.required);

  async ngOnInit() {
    await this.findWebhooks();
  }

  async findWebhooks() {
    try {
      LoaderService.showLoader();
      const [rec, cob, cobr] = await Promise.all([
        lastValueFrom(
          this.financialAdminService
            .getItauWebhook('webhookrec')
            .pipe(map((data) => data.result))
        ),
        lastValueFrom(
          this.financialAdminService
            .getItauWebhook('webhook')
            .pipe(map((data) => data.result))
        ),
        lastValueFrom(
          this.financialAdminService
            .getItauWebhook('webhookcobr')
            .pipe(map((data) => data.result))
        )
      ]);
      this.webhookrec.setValue(rec?.webhookUrl);
      this.webhook.setValue(cob?.webhookUrl);
      this.webhookcobr.setValue(cobr?.webhookUrl);
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  async updateWebhook(webhook: 'webhookrec' | 'webhook' | 'webhookcobr') {
    if (this[webhook].valid && this[webhook].touched && this[webhook].dirty)
      try {
        LoaderService.showLoader();
        const detail = await lastValueFrom(
          this.financialAdminService
            .updateItauWebhook({ webhookUrl: this[webhook].value }, webhook)
            .pipe(map((data) => data.result))
        );
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail
        });
        this[webhook].markAsPristine();
        this[webhook].markAsUntouched();
        this[webhook].updateValueAndValidity();
      } catch (error) {
        AppDialogService.showErrorDialog(error);
      } finally {
        LoaderService.showLoader(false);
      }
  }

  async removeWebhook(webhook: 'webhookrec' | 'webhook' | 'webhookcobr') {
    if (this[webhook].value?.trim()?.length)
      try {
        LoaderService.showLoader();
        const detail = await lastValueFrom(
          this.financialAdminService
            .deleteItauWebhook(webhook)
            .pipe(map((data) => data.result))
        );
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail
        });
        this[webhook].reset();
      } catch (error) {
        AppDialogService.showErrorDialog(error);
      } finally {
        LoaderService.showLoader(false);
      }
  }

  get wrongSuffix() {
    return (
      this.webhook?.valid &&
      this.webhook.value.split('/').pop()?.toLowerCase() === 'pix'
    );
  }
}
